// extracted by mini-css-extract-plugin
export var borderTop = "_k-3";
export var linkIcon = "_k-5";
export var linkIconSm = "_k-6";
export var linkOutCard = "_k-7 _k-4";
export var linkRow = "_k-2";
export var pageContainer = "_k-1";
export var providerIcon = "_k-8";
export var roundedBorder = "_k-4";
export var settingsContent = "_k-0";